import React, { createRef, Component } from 'react';
import { useZoomLevel } from '@atlassian/jira-portfolio-3-horizontal-scrolling';
import { wrapHorizontalScrollView } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/horizontal-scrolling';
import { withSlots, slots } from '@atlassian/jira-portfolio-3-portfolio/src/common/component-slots';
import { manuallyUpdateReactVirtualizedListWidth } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/magic';

import Axis from './axis';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './header/styles.module.css';
import InfiniteAxis from './infinite-axis';
import NowLine from './now';
import Schedule from './schedule';
import type { Props } from './types';

const ChooseAxis = () => {
	const [zoomLevel] = useZoomLevel();
	return zoomLevel === undefined ? <Axis /> : <InfiniteAxis />;
};

// eslint-disable-next-line jira/react/no-class-components
export class Timeline extends Component<Props> {
	static defaultProps = {
		Axis: ChooseAxis,
		NowLine,
		Schedule,
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onExperienceSuccess: () => {},
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any, react/sort-comp
	containerRef = createRef<any>();

	componentDidMount() {
		this.props.onExperienceSuccess();
	}

	shouldComponentUpdate(nextProps: Props) {
		if (nextProps.isDragging && this.props.width !== nextProps.width && this.containerRef.current) {
			manuallyUpdateReactVirtualizedListWidth(this.containerRef.current, nextProps.width);
		}
		// update the first time isDragging is true
		if (nextProps.isDragging && !this.props.isDragging) {
			return true;
		}
		return !nextProps.isDragging;
	}

	render() {
		// eslint-disable-next-line @typescript-eslint/no-shadow
		const { Axis, NowLine, Schedule, scrollElement, width, isDragging, leftSidebarWidth } =
			this.props;

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<div ref={this.containerRef} className={styles.timeline} aria-hidden>
				{wrapHorizontalScrollView(<Axis />)}
				<Schedule
					scrollElement={scrollElement}
					width={width}
					isDragging={isDragging}
					NowLine={NowLine}
					leftSidebarWidth={leftSidebarWidth}
				/>
			</div>
		);
	}
}

export default withSlots({ NowLine: slots.NowLine })(Timeline);
